import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { CookieDocument } from '~generated/hooks'
import { CookieQuery, CookieQueryVariables } from '~generated/operations'

const useCookie = () => {
  const { data } = useQuery<CookieQuery, CookieQueryVariables>(CookieDocument, { fetchPolicy: 'cache-only' })

  return useMemo(() => {
    return data?.cookie || {}
  }, [data?.cookie])
}

export default useCookie
